import { useMutation } from "@tanstack/react-query";

import { tableSerializationApi } from "src/api/endpoints";

export const useImportMatrixTable = () =>
  useMutation({
    mutationFn: async ({
      flowVersionId,
      nodeId,
      file,
    }: {
      flowVersionId: string;
      nodeId: string;
      file: File;
    }) => {
      return await tableSerializationApi.importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(
        flowVersionId,
        nodeId,
        file,
      );
    },
  });

export const useExportMatrixTable = () =>
  useMutation({
    mutationFn: async ({
      flowVersionId,
      nodeId,
    }: {
      flowVersionId: string;
      nodeId: string;
    }) => {
      const response =
        await tableSerializationApi.exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(
          flowVersionId,
          nodeId,
          { responseType: "blob" },
        );
      return response.data;
    },
  });
